import Population from "./Population.vue";

import PopulationOverview from "./Overview";
import PatientRoutes from "@/module/patient/routes";

const OverviewRoute = {
  path: "",
  component: PopulationOverview,
  props: true,

  icon: "el-icon-odometer",
  text: "Overview",
};

export default [
  {
    path: "patient",
    component: Population,

    children: [OverviewRoute, ...PatientRoutes],
  },
  {
    path: "label/:label",
    component: Population,
    props: true,

    children: [OverviewRoute, ...PatientRoutes],
  },
];
